import { Buffer } from 'buffer'
import { CUSTOM_AGENCIES_PERMISSIONS } from '../apps/saas/constants'
import { ProductType } from '../pmd/components/payments/product.type'
import { USER_ROLE } from '../models/user'
import { aiEmployeePromoRoutes } from '../routes/constants/agency/'
import config from '../config'
import { conversationAIRouteNames } from '../routes/constants/location/'
import isArray from "lodash-es/isArray"
import isObject from "lodash-es/isObject"
import { parsePhoneNumber } from "libphonenumber-js";
import snakeCase from "lodash-es/snakeCase"
import { snapshotsRoutes } from '../routes/constants/agency/snapshots'

const currencySymbols = {
  'USD': '$',
  'GBP': '£',
  'EUR': '€',
  'INR': '₹',
}

export const getCurrencySymbol = (code: any) => {
  // @ts-ignore
  return currencySymbols[code] || code + ' '
}

export const restrictUserByAgencyPermission = (locationPermissions, companyId, route) => {
  const customAgencyConfig = CUSTOM_AGENCIES_PERMISSIONS[companyId];
  if(customAgencyConfig && customAgencyConfig.routes.includes(route) && locationPermissions?.custom_changes_enabled) {
    return true;
  }
  return false
}

export const restrictUserByScopePermission = (scopes: string[], scope: string, route: string) => {
  if(!(scopes || []).includes(scope) && route === snapshotsRoutes.default) {
    return true;
  }
  return false
}

export const getValidUrl = (url = '') => {
  if (!url) return url
  let newUrl = decodeURIComponent(url)
  newUrl = newUrl.trim().replace(/\s/g, '')
  if (/^(:\/\/)/.test(newUrl)) {
    return `http${newUrl}`
  }
  if (!/^(f|ht)tps?:\/\//i.test(newUrl)) {
    return `https://${newUrl}`
  }
  return newUrl
}

export function getHostAndDomain() {
  let host
  // if (window.location.host.indexOf('localhost') === -1) {
  host = window.location.host
  // Remove the dot at end of the value, so that only whitelale domain value will be passed to brand api.
  host = host.replace(/\.$/, "");
  // } else {
  //     host = 'illinitechs.gohighlevel.com';
  // }

  return {
    domain: host,
    subdomain: host.substr(0, host.indexOf('.') || host.length)
  }
}

export const isURL = (url: any) => {
  if (!url || !url.length) return

  const regExp = /([--:\w?@%&+~#=]*\.[a-z]{2,4}\/{0,2})((?:[?&](?:\w+)=(?:\w+))+|[--:\w?@%&+~#=]+)?/
  const match = url.match(regExp)
  return match && match.length
}

export const copyTextToClipboard = (text: string) => {
  const textElem = document.createElement('textarea')
  textElem.innerHTML = text
  document.body.appendChild(textElem)
  textElem.select()
  document.execCommand('copy')
  navigator.clipboard.writeText(textElem.value);
  document.body.removeChild(textElem)
}

export const isSafari = () => {
  return navigator.vendor.toLowerCase().indexOf('apple') > -1
}

export const trackGaEvent = (
  eventCategory: string,
  eventAction: string,
  eventLabel?: string,
  eventValue?: Number
) => {
  // Refer to this doc: https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#events
  if (config.googleAnalyticId && ga) {
    ga(
      'send',
      'event',
      eventCategory,
      eventAction,
      eventLabel || '',
      eventValue || 1
    )
  } else {
    console.table({ 'GA Info': '[Only in Dev Mode]', eventCategory, eventAction, eventLabel, eventValue })
  }
  // To test, add these line, in enviroment configurations:
  // googleAnalyticId: 'UA-115177999-2',

}

export const trackGaPageView = (
  pageName: string,
) => {
  // Refer to this doc: https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#events
  if (config.googleAnalyticId && ga) {
    ga('set', 'page', pageName || '');
    ga( 'send','pageview')
  }
  // To test, add these line, in enviroment configurations:
  // googleAnalyticId: 'UA-115177999-2',

}


export const SnapshotAssetMapper: any = {
  text_templates: 'Text & Email Templates',
  email_templates: 'Email Builder Templates',
  funnels: 'Funnels & Websites',
  links: 'Trigger Links',
  conversation_ai: 'Conversation AI',
  whatsapp_templates: 'WhatsApp Templates',
  ad_campaigns: 'Ad Campaigns - Meta',
  google_ad_campaigns: 'Ad Campaigns - Google'
}

export const trackPendoEvent = (
  eventName: string,
  eventProperties: {[key: string]: any}
) => {
  try {
    if (config.mode === 'production') {
      if (window.pendo) {
        window.pendo.track(eventName, eventProperties)
      }
    } else {
      console.table({
        'PENDO Object': '[only in dev mode]',
        eventName,
        ...eventProperties,
      })
    }
  } catch (error) {
    // console.error('Error in tracking pendo event', error)
  }
}

export const createPriceParams = (
  price: any
) => {
  const priceParams = {
    name: price.name,
    type: price.type,
    currency: price.currency,
    amount: price.amount,
  }

  if (price.hasOwnProperty('description')) priceParams.description = price.description
  if (price.membershipOffers) priceParams.membershipOffers = price.membershipOffers

  if (price.type === ProductType.RECURRING) {
    if (price.recurring) priceParams.recurring = price.recurring
    if (price.trialPeriod) priceParams.trialPeriod = Number(price.trialPeriod)
    if (price.setupFee) priceParams.setupFee = price.setupFee
    if (price.totalCycles) priceParams.totalCycles = price.totalCycles
  }

  return priceParams
}


export function getFriendlyNumber(no: number){
  if(Number.isInteger(no)){
    return no;
  }else{
    return no.toFixed(2)
  }
}

export function wordpressPlans(){
  const plans = [
    'FOUNDER_SPECIAL',
    'UNLIMITED_MONTHLY',
    'UNLIMITED_YEARLY'
  ]
  return {
    plans,
    labelMap:{
      FOUNDER_SPECIAL: 'Founder\'s Special Offer',
      UNLIMITED_MONTHLY: 'Unlimited Monthly Plan',
      UNLIMITED_YEARLY: 'Unlimited Yearly Plan',
      STANDARD: 'Standard'
    }
  }

}

export function sanitizeDomain(domain: string = ''){
  domain = domain.trim();
  domain = domain.replace(/(\s*\.+\s*)+$/g,'');
  domain = domain.replace(/(\s*\/+\s*)+$/g,'');
  return domain;
}

export function stripDomainProtocol(domain: string = ''){
  domain = domain.trim();
  domain = domain.replace(/^https*\:\/\//,'').trim()
  return domain;
}

export function addHttps(domain: string = ''){
  domain = `https://${stripDomainProtocol(domain)}`
  return domain;
}

export function promiseRace(anyPromise:Promise<any>, timeout:number ){
  return Promise.race([
    anyPromise,
    new Promise((_,reject)=>{
      setTimeout(_=>{
        reject(`Timeout exceed ${timeout}`)
      }, timeout)
    })
  ])
}


const toCamel = function (string) {
  return string.replace(/([a-z0-9])[_]([a-z])/g, function (g) {
    return g[0] + g[2].toUpperCase()
  })
}

export const transformToCamelCase = function (data: any) {
  if (data instanceof Date || data instanceof Buffer || data === null || data === undefined || data === {}) {
    return data
  }
  if (data instanceof Array) {
    return data.map((datum) => transformToCamelCase(datum))
  }
  if (data instanceof Object) {
    const transformedObject = {}

    Object.keys(data).forEach((field) => {
      let dataField: any = data[field]

      if (dataField && dataField._seconds !== undefined && dataField._nanoseconds !== undefined) {
        dataField = new Date(dataField._seconds * 1000 + dataField._nanoseconds / 1000000)
      }

      if (dataField instanceof Object) {
        dataField = transformToCamelCase(dataField)
      }

      transformedObject[toCamel(field)] = dataField
    })

    return transformedObject
  }
  return data
}

export function capitalizeFirstLetter(str: string) {
  return str[0].toUpperCase() + str.slice(1);
}

export const capitalizeWordsFirstLetter = (str: string) => {
  return str?.replace(/\b\w/g, (char) => char.toUpperCase()) || ''
}


export function parseReportingData(data: any) {
  return data.map((obj: any) => {
    const parsedObj: any = {};
    if (obj.adName) parsedObj.adName = obj.adName;
    if(obj.campaign) {
      parsedObj.campaignId = obj.campaign.id;
      parsedObj.campaignName = obj.campaign.name;
      parsedObj.campaignStatus = obj.campaign.status || '';
      parsedObj.campaignStatusText = obj.campaign.status ? capitalizeFirstLetter(obj.campaign.status.toLowerCase()) : '';
    }
    if(obj.adGroup) {
      parsedObj.adGroupId = obj.adGroup.id;
      parsedObj.adGroupName = obj.adGroup.name;
    }
    if(obj.adGroupAd) {
      parsedObj.adId = obj.adGroupAd.ad ? obj.adGroupAd.ad.id : obj.adGroupAd.id;
      if (obj.adGroupAd.status) parsedObj.adStatus = obj.adGroupAd.status;
      parsedObj.ad = {...(obj.adGroupAd?.ad?.data || obj.adGroupAd?.ad || {})}
      if(!parsedObj.ad.name) parsedObj.ad.name = parsedObj.adName || (parsedObj.ad.headlines ? parsedObj.ad.headlines[0].text : '');
      if(parsedObj.ad.descriptions?.length) {
        parsedObj.ad.description = parsedObj.ad.descriptions.reduce((text: string, curr: any) => {
          return text += text.length ? ` | ${curr.text}` : curr.text
        }, '');
      }
      if(parsedObj.ad.headlines?.length) {
        if(!parsedObj.ad.description) parsedObj.ad.description = '';
        parsedObj.ad.description += parsedObj.ad.headlines.reduce((text: string, curr: any) => {
          return text += text.length ? ` | ${curr.text}` : curr.text
        }, '');
      }
      parsedObj.ad.finalUrl = obj.adGroupAd?.ad?.finalUrls ? obj.adGroupAd.ad.finalUrls[0] : null;
    }
    if(obj.adGroupCriterion && obj.adGroupCriterion.keyword) {
      parsedObj.keyword = obj.adGroupCriterion.keyword.text || '--'
    }
    if(obj.metrics) {
      for(let key of Object.keys(obj.metrics)) {
        parsedObj[key] = obj.metrics[key]
      }
    }
    if (parsedObj.clicks) parsedObj.clicks = parseInt(parsedObj.clicks, 10);
    if (parsedObj.averageCpc) parsedObj.averageCpc = parseInt(parsedObj.averageCpc, 10) / 1000000;
    if (parsedObj.viewThroughConversions) parsedObj.viewThroughConversions = parseInt(parsedObj.viewThroughConversions, 10);
    if (parsedObj.costMicros) parsedObj.costMicros = parseInt(parsedObj.costMicros, 10) / 1000000;
    if (parsedObj.impressions) parsedObj.impressions = parseInt(parsedObj.impressions, 10);
    if (parsedObj.conversions) parsedObj.conversions = parseFloat(parsedObj.conversions);
    if (parsedObj.ctr) parsedObj.ctr = parsedObj.ctr * 100;
    if (parsedObj.conversionsFromInteractionsRate) parsedObj.conversionsFromInteractionsRate =
      parseFloat(parsedObj.conversionsFromInteractionsRate);
    if (parsedObj.costPerConversion) parsedObj.costPerConversion = parseInt(parsedObj.costPerConversion, 10) / 1000000;
    return parsedObj;
  });
}

export const formatNumber = (value: any) => {
  return new Intl.NumberFormat(
    navigator.language,
    {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(Number(value))
}

export const formatDecimal = (value: any) => {
  return new Intl.NumberFormat(
    navigator.language,
    {
      style: 'decimal'
    }).format(Number(value))
}

export const formatPercent = (value: any) => {
  return new Intl.NumberFormat(
    navigator.language,
    {
      style: 'percent',
      minimumFractionDigits: 2
    }).format(Number(value))
}

export const locationNicheOptions = [
  {
    label: 'Financial Services',
    value: 'finance',
    icon: 'far fa-money-bill-alt',
  },
  {
    label: 'Marketing & Advertising',
    value: 'marketing',
    icon: 'fas fa-bullhorn',
  },
  {
    label: 'Fitness & Lifestyle',
    value: 'fitness',
    icon: 'fas fa-heartbeat',
  },
  {
    label: 'Health & Medical',
    value: 'health',
    icon: 'fas fa-medkit',
  },
  {
    label: 'Online Training & Education',
    value: 'education',
    icon: 'fas fa-university',
  },
  {
    label: 'Real Estate',
    value: 'real_estate',
    icon: 'far fa-building',
  },
  {
    label: 'Home Services',
    value: 'home_services',
    icon: 'fas fa-home',
  },
  {
    label: 'Restaurants',
    value: 'restaurants',
    icon: 'fas fa-pizza-slice',
  },
  {
    label: 'Legal Services',
    value: 'legal',
    icon: 'fas fa-balance-scale',
  },
  {
    label: 'Retail & E-Commerce',
    value: 'retail',
    icon: 'fas fa-truck',
  },
  {
    label: 'Others',
    value: 'others',
    icon: 'fas fa-ellipsis-h',
  },
]

export const A2PCampaignUseCaseOptions = [
  {
    label: 'Low Volume Mixed (Recommended)',
    value: 'LOW_VOLUME'
  },
  {
    label: 'Two-Factor Authentication (2FA)',
    value: '2FA'
  },
  {
    label: 'Account Notification',
    value: 'ACCOUNT_NOTIFICATION'
  },
  {
    label: 'Customer Care',
    value: 'CUSTOMER_CARE'
  },
  {
    label: 'Delivery Notification',
    value: 'DELIVERY_NOTIFICATION'
  },
  {
    label: 'Fraud Alert Messaging',
    value: 'FRAUD_ALERT'
  },
  {
    label: 'Higher Education',
    value: 'HIGHER_EDUCATION'
  },
  {
    label: 'Marketing',
    value: 'MARKETING'
  },
  {
    label: 'Mixed',
    value: 'MIXED'
  },
  {
    label: 'Polling and Voting',
    value: 'POLLING_VOTING'
  },
  {
    label: 'Public Service Announcement',
    value: 'PUBLIC_SERVICE_ANNOUNCEMENT'
  },
  {
    label: 'Security Alert',
    value: 'SECURITY_ALERT'
  },
]

export const A2PStandardCampaignUseCaseOptions = [
  {
    label: 'Mixed (Recommended)',
    value: 'MIXED'
  },
  {
    label: 'Two-Factor Authentication (2FA)',
    value: '2FA'
  },
  {
    label: 'Account Notification',
    value: 'ACCOUNT_NOTIFICATION'
  },
  {
    label: 'Customer Care',
    value: 'CUSTOMER_CARE'
  },
  {
    label: 'Delivery Notification',
    value: 'DELIVERY_NOTIFICATION'
  },
  {
    label: 'Fraud Alert Messaging',
    value: 'FRAUD_ALERT'
  },
  {
    label: 'Higher Education',
    value: 'HIGHER_EDUCATION'
  },
  {
    label: 'Marketing',
    value: 'MARKETING'
  },
  {
    label: 'Polling and Voting',
    value: 'POLLING_VOTING'
  },
  {
    label: 'Public Service Announcement',
    value: 'PUBLIC_SERVICE_ANNOUNCEMENT'
  },
  {
    label: 'Security Alert',
    value: 'SECURITY_ALERT'
  },
]

export const MonthlyMessageVolume = [
  {
    label: '10',
    value: '10'
  },
  {
    label: '100',
    value: '100'
  },
  {
    label: '1,000',
    value: '1,000'
  },
  {
    label: '10,000',
    value: '10,000'
  },
  {
    label: '100,000',
    value: '100,000'
  },
  {
    label: '250,000',
    value: '250,000'
  },
  {
    label: '500,000',
    value: '500,000'
  },
  {
    label: '750,000',
    value: '750,000'
  },
  {
    label: '1,000,000',
    value: '1,000,000'
  },
  {
    label: '5,000,000',
    value: '5,000,000'
  },
  {
    label: '10,000,000+',
    value: '10,000,000+'
  }
]

export const businessType = [
  {
    label: 'Co-operative',
    value: 'Co-operative',
  },
  {
    label: 'Corporation',
    value: 'Corporation',
  },
  {
    label: 'Limited Liability Company Or Sole-Proprietorship',
    value: 'Limited Liability Corporation',
  },
  {
    label: 'Non-profit Corporation',
    value: 'Non-profit Corporation',
  },
  {
    label: 'Partnership',
    value: 'Partnership',
  },
]

export const businessRegistrationType = [
  {
  label: 'USA: Employer Identification Number (EIN)',
  value: 'EIN'
},
  {
    label: 'Canada: Canadian Business Number (CBN)',
    value: 'CBN'
  },
  {
    label: 'Great Britain: Company Number',
    value: 'CN'
  },
  {
    label: 'Australia: Company Number from ASIC (ACN)',
    value: 'ACN'
  },
  {
    label: 'India: Corporate Identity Number',
    value: 'CIN'
  },
  {
    label: 'Estonia: VAT Number',
    value: 'VAT'
  },
  {
    label: 'Israel: Registration Number',
    value: 'RN'
  },
  {
    label: 'Other',
    value: 'Other'
  }
]

export const jobPositionOptions = [
  {
    label: 'Director',
    value: 'Director',
  },
  {
    label: 'GM',
    value: 'GM',
  },
  {
    label: 'VP',
    value: 'VP',
  },
  {
    label: 'CEO',
    value: 'CEO',
  },
  {
    label: 'CFO',
    value: 'CFO',
  },
  {
    label: 'General Counsel',
    value: 'General Counsel',
  },
  {
    label: 'Other',
    value: 'Other',
  },
]

export const businessIndustry = [
  {
  label: 'Automotive',
  value: 'AUTOMOTIVE'
},
  {
    label: 'Agriculture',
    value: 'AGRICULTURE'
  },
  {
    label: 'Banking',
    value: 'BANKING'
  },
  {
    label: 'Consumer',
    value: 'CONSUMER'
  },
  {
    label: 'Education',
    value: 'EDUCATION'
  },
  {
    label: 'Engineering',
    value: 'ENGINEERING'
  },
  {
    label: 'Energy',
    value: 'ENERGY'
  },
  {
    label: 'Oil and Gas',
    value: 'OIL_AND_GAS'
  },
  {
    label: 'Fast moving consumer goods',
    value: 'FAST_MOVING_CONSUMER_GOODS'
  },
  {
    label: 'Financial',
    value: 'FINANCIAL'
  },
  {
    label: 'Fintech',
    value: 'FINTECH'
  },
  {
    label: 'Food and Beverage',
    value: 'FOOD_AND_BEVERAGE'
  },
  {
    label: 'Government',
    value: 'GOVERNMENT'
  },
  {
    label: 'Healthcare',
    value: 'HEALTHCARE'
  },
  {
    label: 'Hospitality',
    value: 'HOSPITALITY'
  },
  {
    label: 'Insurance',
    value: 'INSURANCE'
  },
  {
    label: 'Legal',
    value: 'LEGAL'
  },
  {
    label: 'Manufacturing',
    value: 'MANUFACTURING'
  },
  {
    label: 'Media',
    value: 'MEDIA'
  },
  {
    label: 'Online',
    value: 'ONLINE'
  },
  {
    label: 'Raw Materials',
    value: 'RAW_MATERIALS'
  },
  {
    label: 'Real Estate',
    value: 'REAL_ESTATE'
  },
  {
    label: 'Religion',
    value: 'RELIGION'
  },

  {
    label: 'Retail',
    value: 'RETAIL'
  },
  {
    label: 'Jewelry',
    value: 'JEWELRY'
  },
  {
    label: 'Technology',
    value: 'TECHNOLOGY'
  },
  {
    label: 'Telecommunications',
    value: 'TELECOMMUNICATIONS'
  },
  {
    label: 'Transportation',
    value: 'TRANSPORTATION'
  },
  {
    label: 'Travel',
    value: 'TRAVEL'
  },
  {
    label: 'Electronics',
    value: 'ELECTRONICS'
  },
  {
    label: 'Not for profit',
    value: 'NOT_FOR_PROFIT'
  }
]

export const businessVerticals = [
  {
    label: 'Agriculture',
    value: 'AGRICULTURE'
  },
  {
    label: 'Communication',
    value: 'COMMUNICATION'
  },
  {
    label: 'Construction',
    value: 'CONSTRUCTION'
  },
  {
    label: 'Education',
    value: 'EDUCATION'
  },
  {
    label: 'Energy',
    value: 'ENERGY'
  },
  {
    label: 'Entertainment',
    value: 'ENTERTAINMENT'
  },
  {
    label: 'Financial',
    value: 'FINANCIAL'
  },
  {
    label: 'Gambling',
    value: 'GAMBLING'
  },
  {
    label: 'Government',
    value: 'GOVERNMENT'
  },
  {
    label: 'Healthcare',
    value: 'HEALTHCARE'
  },
  {
    label: 'Hospitality',
    value: 'HOSPITALITY'
  },
  {
    label: 'Human Resources',
    value: 'HUMAN_RESOURCES'
  },
  {
    label: 'Insurance',
    value: 'INSURANCE'
  },
  {
    label: 'Legal',
    value: 'LEGAL'
  },
  {
    label: 'Manufacturing',
    value: 'MANUFACTURING'
  },
  {
    label: 'NGO',
    value: 'NGO'
  },
  {
    label: 'Political',
    value: 'POLITICAL'
  },
  {
    label: 'Postal',
    value: 'POSTAL'
  },
  {
    label: 'Professional',
    value: 'PROFESSIONAL'
  },
  {
    label: 'Real Estate',
    value: 'REAL_ESTATE'
  },
  {
    label: 'Retail',
    value: 'RETAIL'
  },
  {
    label: 'Technology',
    value: 'TECHNOLOGY'
  },
  {
    label: 'Transportation',
    value: 'TRANSPORTATION'
  }
];


export function generateRandomPassword(length: number = 12) {
  let chars = '0123456789abcdefghijklmnopqrstuvwxyz@&ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  let password = '';
  while (true) {
    password = '';
    const array = new Uint32Array(chars.length);
    window.crypto.getRandomValues(array);
    for (let i = 0; i < length; i++) {
      password += chars[array[i] % chars.length];
    }
    let upperCase = /[A-Z]+/.test(password)
    let lowerCase = /[a-z]+/.test(password)
    let number = /[0-9]+/.test(password)
    if(upperCase && lowerCase && number){
      break;
    }else{
      console.log('password not valid')
      continue;
    }
  }

  return password;
}

export function generateOtp(length: number = 4) {
  let chars = '0123456789';
  let otp = '';
  const array = new Uint32Array(chars.length);
  window.crypto.getRandomValues(array);
  for (let i = 0; i < length; i++) {
    otp += chars[array[i] % chars.length];
  }
  return otp;
}

export function getShareLink(shareId: string, referralId?: string) {
  let link = ''
  switch (config.mode) {
    case 'production': {
      link = `https://affiliates.gohighlevel.com/?fp_ref=${referralId}&share=${shareId}`
      break
    }
    case 'dev': {
      link = `http://localhost:8080/settings/snapshot/import/${shareId}`
      break
    }
    case 'staging': {
      link = `https://affiliate-dot-highlevel-staging.appspot.com/?fp_ref=${referralId}&share=${shareId}`
      break
    }
    case 'interop': {
      link = `https://affiliate-dot-highlevel-staging.appspot.com/?fp_ref=${referralId}&share=${shareId}`
      break
    }
    default: {
      link = `https://${window.location.hostname}/settings/snapshot/import/${shareId}`
    }
  }

  return link
}

export function convertObjKeysToSnakeRecursively(
  object: string,
  skipKeysFor?: string[]
) {
  if (isArray(object)) {
    return object.map(i => {
      return convertObjKeysToSnakeRecursively(i)
    })
  }
  else if (isObject(object)) {
    const n = {}
    Object.keys(object).forEach(k => {
      if(skipKeysFor && skipKeysFor.includes(k)) {
        n[snakeCase(k)] = null;
        return;
      }
      n[snakeCase(k)] = convertObjKeysToSnakeRecursively(object[k])
    })
    return n
  }
  return object
}

function formatObjectWithLocationsId(object) {
  const result = {};
  if(object)
  {
    Object.keys(object).map((key: string)=> {
    Object.assign(result,{[key]: convertObjKeysToSnakeRecursively(object[key])});
  })
}
  return result;
}

export function transformUserApiData(userApiData) {
  const userData = convertObjKeysToSnakeRecursively(userApiData, [
    'locationWiseOpenHours',
    'locations',
    'userCalendar',
    'locationWiseTimezone',
    'locationWiseMeetingLocation',
    'locationWiseZoomAdded',
    'twilioPhone'
  ])
  Object.assign(userData, {
    role: userData?.roles?.role,
    type: userData?.roles?.type,
    last_name_lower_case: userData?.last_name?.toLowerCase(),
    email_lower_case: userData?.email?.toLowerCase(),
    first_name_lower_case: userData?.first_name?.toLowerCase(),
    locations: formatObjectWithLocationsId(userApiData.locations),
    user_calendar: formatObjectWithLocationsId(userApiData.userCalendar),
    location_wise_open_hours: formatObjectWithLocationsId(userApiData.locationWiseOpenHours),
    location_wise_timezone: formatObjectWithLocationsId(userApiData.locationWiseTimezone),
    location_wise_meeting_location: formatObjectWithLocationsId(userApiData.locationWiseMeetingLocation),
    location_wise_zoom_added: formatObjectWithLocationsId(userApiData.locationWiseZoomAdded),
    location_wise_day_of_the_weekwise_availability: formatObjectWithLocationsId(userApiData.locationWiseDayOfTheWeekwiseAvailability),
    platformLanguage:userData?.platform_language,
    twilio_phone: formatObjectWithLocationsId(userApiData.twilioPhone)
  })
  return userData;
}

export function transformLocationApiData(locationApiData) {
  const locObj = convertObjKeysToSnakeRecursively(locationApiData.data)
  Object.assign(locObj, {
    gmb_business_scope_exist: locationApiData.gmbMessagingScopeExist,
    name_lower_case: locationApiData.name.toLowerCase()
  })
  return locObj;
}

export const formatPhoneNumberE164 = (phone: string, countryCode?: string) => parsePhoneNumber(phone, countryCode).format("E.164")



/**
 * This are our internal production company ids
 */
export const internalProductionCompanyIds = ['YuTUZlUtrwBtvmgByZDW', 'ktapXmiRvMM4pJHyN3b3'];

export const isXeroAllowedForLocation = (locationId: string, companyId?: string): boolean => {
  if(  process.env.NODE_ENV === 'staging' ||  process.env.NODE_ENV === 'development'  ) return true
  const allowedLocationIds = [
    'G0Y7A89mUXT5tvB09vkR', 'hAmjp7gA8wZFvV5TXdgD', 'W7ieBHs6u1K0MbPQFdui', 'HmYhGGzq8YDMaIJGGRtQ', 'KvAcMX7KjwlMEpz22GBg', 'MSsYndmZrkerYLxOvNar', 'EchWQXe2epTMkKXr0Rr8', 'nUvhsTjutuEyXjlgFqiY', 'XCsMEL9ZAABqfXYg1EUm' , 'bsNa4gZFKkkoOy4pAlae', 'bRXT1kpQoY5yOvccqJBB', 'CHfobyvjZI0thYgoZ2E8', 'StMxC7knksWqC3dmr3aS', 'VLEL0xP4mj7wuzG4bdIY', 'DxIsvCBedqNeKiR8VntI', 'iRUe24K7mRghVAuYtd4x', 'UD4XPo3QC6D09nXnh6g9', 'CtTbIX55Hw76Ek6l8yIx', 'aDxFNURBM7eYWIDoE9wH', 'Me9j32MmAI0jGwxJYhiV', 'ZM1Zc2KbTQVdVmz33Cgq', 'phJ5YaxdtXlp90WM4G9I', 'ykLj1LYe4I6CyOf4Vd5h', '6Mj02S44g0RTqsnWnqTS', 'LpmRMrV1j7TBUgZpagmR', '6yfFIatDw2JGwPdVYQO6', 'ghEQ21inbGDpbNQoSou5', 'l3GqA1cqtMsHPBDh8FRM', 'Pwa73KmhR4XvRQm8hW0q'
  ];
  if (allowedLocationIds.includes(locationId)) return true;
  if (companyId && internalProductionCompanyIds.includes(companyId)) return true;
  return false;
}



export const addPrefixToKeyIfNotAlready = (prefix, fieldKey) => {
  // Check if 'fieldKey' already starts with 'model'
  if (fieldKey.startsWith(`${prefix}.`)) {
    // 'fieldKey' already has 'model' at the beginning, do nothing
  } else if (fieldKey.includes('.')) {
    // 'fieldKey' contains '.' but does not start with 'model.', throw an error
    throw new Error(`Invalid key - "${fieldKey}"`)
  } else {
    // 'model' does not contain '.', concatenate 'model' and 'fieldKey'
    fieldKey = `${prefix}.${fieldKey}`
  }

  return fieldKey
}


const retryStoreDataCheck = async (store, maxAttempts = 5, delay = 200) => {
  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    if (store.state?.company?.company && store.state?.user?.user) {
      return true;
    }
    await new Promise(resolve => setTimeout(resolve, delay));
  }
  return false;
}

export const checkAndRedirectToSummerOfAI = async (
  {
    store,
    router,
    locationId,
    next,
    allowRedirect = true
  }: {
    store: any,
    router: any,
    locationId: string,
    next?: any,
    allowRedirect?: boolean
  }) => {
  try {
    const hasStoreData = await promiseRace(retryStoreDataCheck(store), 1500);
    if (!hasStoreData) {
      console.warn('Store data not available after retries');
      return false;
    }

    const showSummerOfAIMenu = await store.dispatch('onboarding/checkAndSetSummerOfAI', {
      locationId,
      companyId: store.state?.company?.company?.id,
      companyStatus: store.state?.company?.company?.status,
      userRole: store.state?.user?.user?.role || 'admin'
    })

    if(showSummerOfAIMenu) {
      const params = locationId ? { location_id: locationId } : {}
      // if allowRedirect is false, we don't want to use redirection
      if(allowRedirect) {
        if(router) {
          router.push({
            name: locationId ? conversationAIRouteNames.aiEmployeePromoLocation : aiEmployeePromoRoutes.default,
            params,
          })
        } else {
          next({
            name: locationId ? conversationAIRouteNames.aiEmployeePromoLocation : aiEmployeePromoRoutes.default,
            params,
          })
        }
      }
      return true
    }

  } catch (error) {
    console.error(error)
  }
  return false
}

